const timelineElements = [
  // --- PAGE 1: Professional Full-Stack Experience ---
  {
    id: 1,
    title: "Full Stack Developer",
    location: "Wealthcraft Innovation",
    description:
      "Leading the development of complex financial infrastructure and high-performance data visualization systems. Architecting scalable solutions and advanced charting components.",
    buttonText: "Company Website",
    date: "December 2025 - Present",
    icon: "work",
  },
  {
    id: 2,
    title: "Full Stack Developer",
    location: "Printogether",
    description:
      "Developed a full-stack 3D printing marketplace using Next.js 14, TypeScript, and Tailwind CSS. Optimized performance by reducing bundle size by 30% and managed 100+ product listings.",
    buttonText: "View Project",
    date: "January 2025 - April 2025",
    icon: "work",
  },
  {
    id: 3,
    title: "Full Stack Developer",
    location: "Harmaig Jeweller",
    description:
      "Built and deployed a high-traffic WebApp featuring 100+ product listings. Focused on codebase optimization, performance tuning, and resolving critical bugs.",
    buttonText: "View Project",
    date: "June 2024 - November 2024",
    icon: "work",
  },
  {
    id: 4,
    title: "Full Stack Developer",
    location: "Mojo Web Technologies",
    description:
      "Developed an Image Caption Generator utilizing ClarifAI, processing 500+ images weekly. Built and maintained data pipelines, improving processing efficiency by 20%.",
    buttonText: "View Project",
    date: "July 2023 - April 2024",
    icon: "work",
  },
  {
    id: 5,
    title: "Tech Intern",
    location: "Newton School",
    description:
      "Acting as the bridge between students and faculty while managing a large student community. Responsible for 100+ daily resume evaluations and mock interview scheduling.",
    buttonText: "View Frontend Projects",
    date: "August 2022 - May 2023",
    icon: "work",
  },
  {
    id: 6,
    title: "DevRel",
    location: "Keploy",
    description:
      "Bridged the gap between developers and the Keploy ecosystem. Created server-side logic and outward-facing web elements to enhance the developer experience.",
    buttonText: "View Backend Projects",
    date: "July 2022 - October 2022",
    icon: "work",
  },
  {
    id: 7,
    title: "Future Ready Talent Intern",
    location: "Microsoft",
    description:
      "Learned in-demand Azure cloud and security skills aligned to industry needs. Prepared to solve business challenges and create innovative solutions using Microsoft Azure and GitHub tools.",
    buttonText: "Company Website",
    date: "October 2021 - October 2022",
    icon: "work",
  },

  // --- PAGE 2: Open Source, Community & Early Internships ---
  {
    id: 8,
    title: "Open Source Mentor & Project Admin",
    location: "GirlScript Summer Of Code",
    description:
      "Mentored 500+ students across multiple open-source programs including GSSoC 22/23. Managed projects like PollItUp and CodeSetGo, handling 100+ pull requests.",
    buttonText: "Project Details",
    date: "March 2022 - July 2022",
    icon: "work",
  },
  {
    id: 9,
    title: "React Developer Intern",
    location: "Mitambi Solutions",
    description:
      "Developed Login/SignUp pages with Firebase Authentication, a Social Media Web App, and a comprehensive Hostel Management Dashboard for all cities in India.",
    buttonText: "Company Website",
    date: "July 2021 - October 2021",
    icon: "work",
  },
  {
    id: 10,
    title: "Associate React Developer Intern",
    location: "The Entrepreneurship Network",
    description:
      "Developed a frontend replica of the official TEN website and created a functional dashboard while maintaining strict daily deadlines.",
    buttonText: "Company Website",
    date: "August 2021 - November 2021",
    icon: "work",
  },
  {
    id: 11,
    title: "Cyber Security Intern",
    location: "Gurugram Police",
    description:
      "Successfully completed the Cyber Security Summer Internship, gaining insights into cybercrime methods, prevention measures, and Indian cyber legislation.",
    buttonText: "Program Details",
    date: "June 2021 - July 2021",
    icon: "work",
  },
  {
    id: 12,
    title: "Web Development Intern",
    location: "Galaxies Group of Technology",
    description:
      "Built and optimized product websites for clients, including Sky-cut. Updated client websites, resolved bugs, and developed the Paras Infotech website.",
    buttonText: "Company Website",
    date: "February 2021 - May 2021",
    icon: "work",
  },
  {
    id: 13,
    title: "Community BUIDLer",
    location: "Binance",
    description:
      "Established a vibrant ecosystem for crypto-literate students to push blockchain boundaries and provided growth opportunities through latest event information.",
    buttonText: "College Projects",
    date: "January 2022 - January 2023",
    icon: "work",
  },
  {
    id: 14,
    title: "Community Builder",
    location: "Apli.ai",
    description:
      "Collaborated with placement officers and the core team to increase placement opportunities and career growth for college students.",
    date: "December 2021 - January 2022",
    icon: "work",
  },
  {
    id: 15,
    title: "Community Builder",
    location: "Scaler",
    description:
      "Selected as one of the Scaler Elites to drive engagement for a community of 100k+ members. Conducted technical doubt-clearing sessions and resume reviews.",
    date: "December 2021 - January 2022",
    icon: "work",
  }
];

export default timelineElements;